import script from "./PluginSection.vue?vue&type=script&lang=ts&setup=true"
export * from "./PluginSection.vue?vue&type=script&lang=ts&setup=true"

import "./PluginSection.vue?vue&type=style&index=0&id=16414b3f&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-16414b3f"]])

export default __exports__